var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},_vm._l((_vm.listInfo),function(item){return _c('router-link',{key:item.id,attrs:{"tag":"li","to":{name:'DepartmentXq',params:{id:item.id}}}},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":item.image,"alt":"图片"}})]),_vm._v(" "),_c('p',{staticClass:"overhid"},[_vm._v(_vm._s(item.title))])])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a020213a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/department/departList.vue
// module id = null
// module chunks = 